import { create } from 'zustand'

interface DashboardLayoutStore {
    // Layout lock state
    isLocked: boolean
    setIsLocked: (isLocked: boolean) => void
    toggleLock: () => void
    // Storage key for localStorage persistence
    storageKey: string | null
    setStorageKey: (key: string) => void
    resetLayout: () => void
    // Widget store drawer state
    isStoreOpen: boolean
    setIsStoreOpen: (isOpen: boolean) => void
    toggleStore: () => void
    // Current department for widget filtering
    currentDepartment: string | null
    setCurrentDepartment: (department: string) => void
    // Available widget count for badge
    availableWidgetCount: number
    setAvailableWidgetCount: (count: number) => void
}

export const useDashboardLayoutStore = create<DashboardLayoutStore>(
    (set, get) => ({
        // Layout lock
        isLocked: false,
        setIsLocked: (isLocked: boolean) => set({ isLocked }),
        toggleLock: () => set((state) => ({ isLocked: !state.isLocked })),
        // Storage key
        storageKey: null,
        setStorageKey: (key: string) => set({ storageKey: key }),
        resetLayout: () => {
            const { storageKey } = get()
            if (storageKey) {
                localStorage.removeItem(storageKey)
                window.location.reload()
            }
        },
        // Widget store drawer
        isStoreOpen: false,
        setIsStoreOpen: (isOpen: boolean) => set({ isStoreOpen: isOpen }),
        toggleStore: () =>
            set((state) => ({ isStoreOpen: !state.isStoreOpen })),
        // Current department
        currentDepartment: null,
        setCurrentDepartment: (department: string) =>
            set({ currentDepartment: department }),
        // Available widget count
        availableWidgetCount: 0,
        setAvailableWidgetCount: (count: number) =>
            set({ availableWidgetCount: count }),
    })
)
